__turbopack_context__.v({
  "brand": "productCard-module-scss-module__14TFda__brand",
  "button": "productCard-module-scss-module__14TFda__button",
  "buttonWrapper": "productCard-module-scss-module__14TFda__buttonWrapper",
  "cardWrapper": "productCard-module-scss-module__14TFda__cardWrapper",
  "centerText": "productCard-module-scss-module__14TFda__centerText",
  "default": "productCard-module-scss-module__14TFda__default",
  "excerpts": "productCard-module-scss-module__14TFda__excerpts",
  "horizontal": "productCard-module-scss-module__14TFda__horizontal",
  "image": "productCard-module-scss-module__14TFda__image",
  "imageAboveInfo": "productCard-module-scss-module__14TFda__imageAboveInfo",
  "imageWrapper": "productCard-module-scss-module__14TFda__imageWrapper",
  "info": "productCard-module-scss-module__14TFda__info",
  "infoWrapper": "productCard-module-scss-module__14TFda__infoWrapper",
  "innerWrapper": "productCard-module-scss-module__14TFda__innerWrapper",
  "input": "productCard-module-scss-module__14TFda__input",
  "productInfo": "productCard-module-scss-module__14TFda__productInfo",
  "pulse": "productCard-module-scss-module__14TFda__pulse",
  "showBorder": "productCard-module-scss-module__14TFda__showBorder",
  "size": "productCard-module-scss-module__14TFda__size",
  "skeletonBase": "productCard-module-scss-module__14TFda__skeletonBase",
  "skeletonButtonCart": "productCard-module-scss-module__14TFda__skeletonButtonCart",
  "skeletonButtonQty": "productCard-module-scss-module__14TFda__skeletonButtonQty",
  "skeletonButtons": "productCard-module-scss-module__14TFda__skeletonButtons",
  "skeletonImage": "productCard-module-scss-module__14TFda__skeletonImage",
  "skeletonPrice": "productCard-module-scss-module__14TFda__skeletonPrice",
  "skeletonSize": "productCard-module-scss-module__14TFda__skeletonSize",
  "skeletonTitle": "productCard-module-scss-module__14TFda__skeletonTitle",
  "title": "productCard-module-scss-module__14TFda__title",
  "toastWrapper": "productCard-module-scss-module__14TFda__toastWrapper",
  "unavailable": "productCard-module-scss-module__14TFda__unavailable",
  "unavailableWrapper": "productCard-module-scss-module__14TFda__unavailableWrapper",
});
